$('body').on('click', '.feed-comments-btn', function () {
    $.ajax({
        url: $(this).attr('data-url'),
        type: 'GET',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            $('#commentsModal .modal-body').html(data.data);
            $('input#comment_ad_uuid').val(data.ad_uuid);
            $('#commentsModal').modal('show');
            $("#commentsModal").animate({scrollTop: $('#commentsModal').height()}, 1000);
            //$('#commentsModal').scrollTo()
        }
    });
});

$('body').on('click', '.feed-shares-btn', function () {
    $.ajax({
        url: $(this).attr('data-url'),
        type: 'GET',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            $('#shareModalBody .facebook').attr('href', data.shares['facebook']);
            $('#shareModalBody .twitter').attr('href', data.shares['twitter']);
            $('#shareModalBody .linkedin').attr('href', data.shares['linkedin']);
            $('#shareModalBody .whatsapp').attr('href', data.shares['whatsapp']);

            $('#shareModal').modal('show');
        }
    });
});

$('body').on('click', '.feed-message-btn', function () {
    $.ajax({
        url: $(this).attr('data-url'),
        type: 'GET',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        success: function (data) {
            if (data.status === true) {
                $('#sendMessageModal form').attr('action', data.data);
                $('#sendMessageModal').modal('show');
            } else {
                if (data.redirect.length > 0) {
                    console.log(data.redirect);
                    window.location = data.redirect;
                }
            }
        }
    });
});
